import APP_ACTIONS from '../constants/app-actions';
import APP_DEFAULTS from '../constants/app-defaults';
import localStorageAPI from '../services/local-storage-api';
import ConfigsAPI from '../apis/configs';

const cartState = {
    updateConfigsActiveCart: () => (dispatch, getState) => ConfigsAPI.getConfigs()
        .then((response) => {
            dispatch({ type: APP_ACTIONS.SET_BACKEND_CONFIG, payload: response.body });
            if (response.body.activeCart && response.body.activeCart.activeCart) {
                dispatch({
                    type: APP_ACTIONS.SET_CONFIGS_ACTIVE_CART,
                    payload: {
                        activeCart: true,
                        cartRemoval: response.body.activeCart.cartRemoval,
                        gracePeriod: response.body.activeCart.gracePeriod,
                    },
                });
            } else {
                dispatch({ type: APP_ACTIONS.SET_ACTIVE_CART, payload: false });
            }
            localStorageAPI.save(getState());
            return response;
        })
        .catch((reason) => {
            dispatch({ type: APP_ACTIONS.SET_ACTIVE_CART, payload: false });
            localStorageAPI.save(getState());
            if (process.env.REACT_APP_ENV !== 'production') {
                console.error('It has not been possible to load the values of the active cart, so the values set for the environment are used.', reason);
            }
            throw reason;
        }),
    setTimeMinutesLeft: (minutes) => (dispatch, getState) => {
        const { cartState: { timeMinutesLeft } } = getState();
        if (timeMinutesLeft !== minutes) {
            dispatch({ type: APP_ACTIONS.UPDATE_MINUTES_TIME_LEFT_CART, payload: minutes });
            return minutes;
        }
    },
    setTimeSecondsLeft: (seconds) => (dispatch, getState) => {
        if (seconds === 0) {
            dispatch({ type: APP_ACTIONS.UPDATE_SECONDS_TIME_LEFT_CART, payload: 0 });
        }
        const { cartState: { timeSecondsLeft } } = getState();
        if (seconds && timeSecondsLeft !== seconds) {
            dispatch({ type: APP_ACTIONS.UPDATE_SECONDS_TIME_LEFT_CART, payload: seconds });

            const { cartState: { timeSecondsLeft, lastAlert } } = getState();
            const lastMinuteWarning = APP_DEFAULTS.showCartExpiringMessageAt.sort((a, b) => a - b)[0];
            const minute = timeSecondsLeft / 60;
            if (minute <= lastMinuteWarning && !lastAlert && timeSecondsLeft !== 0) {
                dispatch({ type: APP_ACTIONS.SET_LAST_ALERT_TIME_LEFT_CART, payload: true });
            } else if ((lastAlert && minute > lastMinuteWarning) || timeSecondsLeft === 0) {
                dispatch({ type: APP_ACTIONS.SET_LAST_ALERT_TIME_LEFT_CART, payload: false });
            }

            return seconds;
        }
    },
    setHasExtraTimeCheckout: (hasExtra) => (dispatch, getState) => {
        const { cartState: { hasExtraTimeCheckout } } = getState();
        if (hasExtraTimeCheckout !== hasExtra) {
            dispatch({ type: APP_ACTIONS.SET_EXTRA_TIME_CHECKOUT, payload: hasExtra });
            localStorageAPI.save(getState());
        }
    },
};

export default cartState;



/** WEBPACK FOOTER **
 ** ./src/actions/cart-state.js
 **/